import { NSARouterMakerResult } from 'namirasoft-account-react';
import { Component } from 'react';
import { NSBox, NSBoxFile, NSButtonBlue, NSPanel } from 'namirasoft-site-react';
import * as XLSX from 'xlsx';

export interface ImportFileStepProps extends NSARouterMakerResult
{
    onComplete: (csvHeaders: string[], csvBody: string[][]) => void;
}

interface ImportFileStepState
{
    selected_file?: Blob;
}

class ImportFileStep extends Component<ImportFileStepProps, ImportFileStepState>
{
    constructor(props: ImportFileStepProps)
    {
        super(props);
        this.state = {};
        this.readCSV = this.readCSV.bind(this);
    }

    readCSV(onFinished: () => void)
    {
        try
        {
            let file = this.state.selected_file;

            if (!file || file.type !== 'text/csv')
            {
                this.props.notifier.onError('Please select a CSV file');
                return onFinished();
            }

            let reader = new FileReader();

            reader.onload = (event) =>
            {
                try
                {
                    let text = event.target?.result as string;
                    let workbook = XLSX.read(text, { type: 'string' });
                    let sheet = workbook.Sheets[workbook.SheetNames[0]];
                    let rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '', blankrows: false }) as string[][];

                    let csv_headers = rows.shift() ?? [];
                    let csv_body = rows.filter(row => row.length >= 5);

                    this.props.onComplete(csv_headers, csv_body);
                    onFinished();
                }
                catch (error)
                {
                    this.props.notifier.onError(error as Error);
                    onFinished();
                }
            };

            reader.onerror = () =>
            {
                this.props.notifier.onError('Failed to read the CSV file');
                onFinished();
            };

            reader.readAsText(file);
        }
        catch (error)
        {
            this.props.notifier.onError(error as Error);
            onFinished();
        }
    }

    override render()
    {
        return (
            <NSPanel style={{ width: '100%', maxWidth: NSBox.width.double, margin: "0 auto" }}>
                <NSBoxFile
                    title="CSV File"
                    required
                    maxFilesCount={1}
                    onSelected={(info) => this.setState(() => ({ selected_file: info.fileList[0]?.originFileObj }))}
                />
                <NSButtonBlue
                    title="Import"
                    onClick={{ showLoading: true, action: this.readCSV }}
                />
            </NSPanel>
        );
    }
}

export default ImportFileStep;